import React, { useMemo } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Img } from 'react-image';
import { Avatar } from '../Components/Avatar';
import Button from '../Components/Button';
import { User } from '../Types/User';

interface SwitchAccountsViewProps {
  parentUser: User;
  studentUsers: User[];
  onSwitchRequested: (user: User) => void;
  onCancel?: () => void;
}
const SwitchAccounts: React.FC<SwitchAccountsViewProps> = ({
  parentUser,
  studentUsers,
  onCancel,
  onSwitchRequested,
}) => {
  const sortedStudentUsers = useMemo(
    () => [...studentUsers].sort((a, b) => a.name.localeCompare(b.name)),
    [studentUsers],
  );

  return (
    <>
      <div className="flex flex-col bg-white rounded-lg p-8 gap-4">
        <header className="flex flex-col items-center justify-between gap-2">
          <Img
            src={[require('../assets/icons/profiles.svg')]}
            alt={'Switch Accounts'}
          />
          <h1 className="text-2xl font-bold">Switch Accounts</h1>

          <div className="w-full">
            {sortedStudentUsers.map((studentUser, i) => (
              <ProfileItem
                user={studentUser}
                onSwitchRequested={onSwitchRequested}
                className={`${i === 0 ? 'rounded-t-lg' : ''} ${i === studentUsers.length - 1 ? 'rounded-b-lg' : ''}`}
              />
            ))}
            <h5 className="text-sm text-gray-700 font-bold text-left mt-3 mb-1">
              Parent
            </h5>
            <ProfileItem
              user={parentUser}
              onSwitchRequested={onSwitchRequested}
              className={`rounded-lg`}
            />
          </div>
          <Button
            variant="round"
            onClick={onCancel}
            className="absolute top-4 right-4"
          >
            <RxCross2 className="w-4 h-4 text-white" />
          </Button>
        </header>
      </div>
    </>
  );
};

interface ProfileItemProps {
  user: User;
  onSwitchRequested: (user: User) => void;
  className?: string;
}
const ProfileItem: React.FC<ProfileItemProps> = ({
  user,
  onSwitchRequested,
  className,
}) => {
  return (
    <>
      <section
        className={`flex cursor-pointer gap-2.5 items-center p-2.5 w-full bg-gray-50 border border-gray-200 hover:bg-blue-50 ${className}`}
        onClick={() => onSwitchRequested?.(user)}
      >
        <Avatar user={user} size={32} />
        <span className="self-stretch my-auto">
          {user.name} {user.surname}
        </span>
      </section>
    </>
  );
};

export default SwitchAccounts;
